import ProductsEntry from './products-entry';
import Flickity from 'flickity';

export default class ProductsEntryMobile extends ProductsEntry {
	constructor(...args) {
		super(...args);
		
	}

	_retrieveDOM(){
		super._retrieveDOM();
		
		this.dom.slider = this.dom.page.querySelector('.js-main-carousel');
		this.dom.prev = this.dom.page.querySelector('.js-related-prev');
		this.dom.next = this.dom.page.querySelector('.js-related-next');
	}

	bind() {
		super.bind();

		this._Flkty = new Flickity( this.dom.slider, {
			cellSelector: '.js-carousel-cell',
			prevNextButtons: false
		});

		console.log(this._Flkty);

		// previous
		this.dom.prev.addEventListener( 'click', () => {
			this._Flkty.previous();
		});
		// next
		this.dom.next.addEventListener( 'click', () => {
			this._Flkty.next();
		});
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/products/entry/products-entry.mobile.js